// Imports for external libraries go here.
import React, { FC } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.

import { StyledLegalSeparator } from './LegalSeparator.styles';

const LegalSeparatorConfig = {
  emptyLabel: 'LegalSeparator',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/separator`,
};

// Use named rather than default exports.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LegalSeparator: FC = (props: any) => {
  return (
    <EditableComponent config={LegalSeparatorConfig} {...props}>
      <StyledLegalSeparator data-testid="legal-LegalSeparator" data-component-name="o-legal-LegalSeparator">
        <hr />
      </StyledLegalSeparator>
    </EditableComponent>
  );
};
